import Vue from "vue";
import babelPolyfill from 'babel-polyfill'
import './plugins/vuetify'
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueHtml2Canvas from 'vue-html2canvas';
import { saveAs } from 'file-saver';
import './assets/main.scss';

Vue.use(VueHtml2Canvas);

Vue.config.productionTip = false;

router.afterEach((to) => {
  document.body.classList.remove("preview-page");
  if (to.path.startsWith("/preview")) {
    document.body.classList.add("preview-page");
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
